<template>
  <div :class="{'error': getError}">
        <slot></slot>
        <div v-if="getError" class="form-control-feedback">{{$t(getError)}}</div>
  </div>
</template>

<script lang="ts" setup>
import { defineProps, computed } from 'vue';

const props = defineProps(['formerror', 'name']);

const getError = computed(() =>
{
    const fieldName = props.name;

    if (props.formerror && props.formerror.errors)
    {
        if (props.formerror.code === 'field_errors')
        {
            for (const error of props.formerror.errors)
            {
                if (error.params && error.params.field === fieldName)
                {
                    return `${error.notice.toUpperCase()}_${error.params.field.toUpperCase()}`;
                }
            }
        }
        else
        {
            for (const error of props.formerror.errors)
            {
                if (error.params && error.params.field && error.params.field === fieldName)
                {
                    return error.notice.toUpperCase();
                }
            }
        }
    }

    if (props.formerror.params && props.formerror.params.field === fieldName)
    {
        return props.formerror.notice.toUpperCase();
    }

    return false;
});
</script>
